/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vaccination } from '../../models/vaccination';

export interface GetVaccination$Params {
  vaccinationId: number;
}

export function getVaccination(http: HttpClient, rootUrl: string, params: GetVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
  const rb = new RequestBuilder(rootUrl, getVaccination.PATH, 'get');
  if (params) {
    rb.path('vaccinationId', params.vaccinationId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vaccination>;
    })
  );
}

getVaccination.PATH = '/api/vaccination/{vaccinationId}';
